var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCompanyProfileIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2204_50)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.75 15.4C13.75 15.8054 13.4425 16.1333 13.0625 16.1333H8.9375C8.55937 16.1333 8.25 15.8033 8.25 15.4V13.2H0V19.8C0 20.9733 0.96293 22 2.0625 22H19.9375C21.0371 22 22 20.9729 22 19.8V13.2H13.75V15.4ZM19.9375 4.4H16.5V2.2C16.5 1.02713 15.5375 0 14.4375 0H7.5625C6.4625 0 5.5 1.02713 5.5 2.2V4.4H2.0625C0.96293 4.4 0 5.42667 0 6.6V11.7333H22V6.6C22 5.42667 21.0375 4.4 19.9375 4.4ZM14.4375 4.4H7.5625V2.2H14.4375V4.4Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2204_50"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyProfileIcon);
export default __webpack_public_path__ + "static/media/companyProfile-icon.8b56d8b21a85b4565c121dc583a7f229.svg";
export { ForwardRef as ReactComponent };